import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=618a97a1&scoped=true&"
import script from "./BillingPage.vue?vue&type=script&lang=js&"
export * from "./BillingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a97a1",
  null
  
)

export default component.exports